const projectData = [
    {
        id: 1,
        image: require('@/assets/images/users/avatar-5.jpg'),
        text: 'Cliente não associado',
        subtext: 'Ponto vista produto testes 001',
        users: [require('@/assets/images/users/post_1.jpg'), require('@/assets/images/users/post_2.jpg')],
        status: 'Concluído',
        date: '15 Jul, 23',
        comment: 5
    },
    {
        id: 2,
        image: require('@/assets/images/users/avatar-2.jpg'),
        text: 'Cliente não associado',
        subtext: 'Ponto vista produto testes 001',
        users: [require('@/assets/images/users/post_3.jpg')],
        status: 'Pendente',
        date: '22 Jul, 23',
        comment: 0
    },
    {
        id: 3,
        image: require('@/assets/images/users/avatar-4.jpg'),
        text: 'Cliente Testes 001',
        subtext: 'Prospecção testes 000455',
        users: [require('@/assets/images/users/post_1.jpg'), require('@/assets/images/users/post_2.jpg')],
        status: 'Atraso',
        date: '13 Jul, 23',
        comment: 0
    },
    {
        id: 4,
        image: require('@/assets/images/users/avatar-8.jpg'),
        text: 'Cliente não associado',
        subtext: '',
        users: [require('@/assets/images/users/post_3.jpg')],
        status: 'Concluído',
        date: '14 Jul, 23',
        comment: 202
    },
    {
        id: 5,
        image: require('@/assets/images/users/avatar-6.jpg'),
        text: 'Cliente não associado',
        subtext: '',
        users: [require('@/assets/images/users/post_3.jpg'), require('@/assets/images/users/post_1.jpg')],
        status: 'Concluído',
        date: '13 Jul, 23',
        comment: 194
    },
];

export { projectData };